import { useState } from "react";
import { Header } from "../../Components/Header";
import Box from "@mui/material/Box";
import { useSearchParams } from "react-router-dom";
import EDPBLogo from "../../Images/ClbEDPBLogo.png";
import { useTranslation } from "react-i18next";
import { SurveyType } from "../../Components/SurveyType";

const Anonymous = () => {
  const { t } = useTranslation("anonymous");

  const [searchParams, setSearchParams] = useSearchParams();

  const [surveyTypeId, setSurveryTypeId] = useState<string>(
    searchParams.get("t") || ""
  );
  const [accountId, setAccountId] = useState<string>(
    searchParams.get("a") || ""
  );
  const [contactId, setContactId] = useState<string>(
    searchParams.get("c") || ""
  );

  return (
    <>
      <Header description={t("Vragenlijst")} />
      <img src={EDPBLogo} alt="CLB EDPB" className="p-3" />
      <Box p={2}>
        <SurveyType
          surveyTypeId={surveyTypeId}
          accountId={accountId}
          contactId={contactId}
        />
      </Box>
    </>
  );
};

export default Anonymous;
